import { AxiosResponse } from 'axios';
import { CommentEntry, SaveCommentPayload } from '../../types/comments';
import api from './client';

export const commentService = {
  list: async (moldOrderId: number): Promise<AxiosResponse<CommentEntry[]>> => {
    return api.get(`/mold-orders/${moldOrderId}/comments`);
  },

  create: async (
    moldOrderId: number,
    authorId: number,
    payload: SaveCommentPayload,
  ): Promise<AxiosResponse<CommentEntry[] | void>> => {
    return api.post(`/mold-orders/${moldOrderId}/comments`, {
      moldOrderId,
      authorId,
      body: payload.body,
      mentions: payload.mentions,
    });
  },

  update: async (
    moldOrderId: number,
    commentId: number,
    payload: SaveCommentPayload,
  ): Promise<AxiosResponse<CommentEntry[] | void>> => {
    return api.patch(`/mold-orders/${moldOrderId}/comments/${commentId}`, {
      body: payload.body,
      mentions: payload.mentions,
    });
  },

  delete: async (
    moldOrderId: number,
    commentId: number,
  ): Promise<AxiosResponse<CommentEntry[] | void>> => {
    return api.delete(`/mold-orders/${moldOrderId}/comments/${commentId}`);
  },
};
